import Reflux from "reflux";

import Chip from "@javascript/reactComponents/lds/chips/Chip";
import { FacetSearchAffiliatedWithActions } from "@javascript/stores/actions/facetSearch/affiliatedWithActions";
import { FacetSearchListActions } from "@javascript/stores/actions/facetSearch/listActions";
import FacetSearchStore from "@javascript/stores/facetSearchStore";

const FacetSearchCriteriaList = createReactClass({
  mixins: [
    Reflux.connectFilter(FacetSearchStore, "list", function(data) {
      return data.userLists.selected
    })
  ],

  getInitialState() {
    return {
      list: FacetSearchStore.data.userLists.selected
    };
  },

  render() {
    const { list } = this.state;
    if (!list) return null;

    const originalListId = Zymewire.original_feed_query && (
      Zymewire.original_feed_query.user_list_id
    );

    const isPublicList = list.listType === "public";

    const isListIdMatching = list.userListId === originalListId;
    const locked = originalListId ? isListIdMatching : false;

    return <ListAppliedFilterEntry
      isPublicList={isPublicList}
      list={list}
      locked={locked}
    />;
  }
});

const ListAppliedFilterEntry = ({
  isPublicList,
  list,
  locked,
}) => {
  const canSeeCmoLists = _.contains(Zymewire.user.feature_tags, "cmo_concepts_and_associations");

  const removeListOrAffiliation = () => {

    if (isPublicList && canSeeCmoLists) {
      FacetSearchAffiliatedWithActions.affiliationRemoved({ doSearch: true });
    } else {
      FacetSearchListActions.unselectList({ doSearch: true });
    }
    return false;
  };


  let label;
  let leadingIcon;
  if (isPublicList && canSeeCmoLists) {
    const affiliationName = list.name
      .replace("Drug sponsors affiliated with ", "")
      .replace(/\b\w/g, char => char.toUpperCase());
    label = `${Zymewire.facet_search_filters.affiliated_with}: ${affiliationName}`;
    leadingIcon = "microscope";
  } else {
    const entityType = String(list.entity_type);
    label = `${Zymewire.facet_search_filters.user_lists}: ${entityType} listed on ${list.name}`;
    leadingIcon = "list";
  }

  return (
    <Chip
      className="search_filter_applied_chip fullstory_excluded"
      label={label}
      leadingIcon={leadingIcon}
      size="small"
      {...!locked && {
        trailingIcon: "cancel",
        trailingIconClassName: "search_filter_applied_trailing_icon",
        trailingIconOnClick: removeListOrAffiliation,
      }}
      variant="secondary"
    />
  );
};

window.FacetSearchCriteriaList = FacetSearchCriteriaList;
export default FacetSearchCriteriaList;
